import isArray from 'lodash/isArray'

export default {
  methods: {
    openLightbox(items = [], index = 0, containerProps = {}) {
      if(!isArray(items)) items = [items];
      this.$root.$emit('lightboxOpen', items, index, containerProps)
    }
  }
}
